/**
 * №14.1.1-C — the pre-auth waiting state, on the one component layer.
 *
 * Shared by `AuthGuard` (restoring a session) and `AuthCallback` (exchanging the
 * OAuth code); both previously carried their own Tailwind + raw-hex copy of it.
 */
import { AuthShell } from "./AuthShell";

export function AuthSpinner({ label }: { label: string }) {
  return (
    <AuthShell>
      <div className="authpane__wait">
        <svg className="authspin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
          <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        </svg>
        {label}
      </div>
    </AuthShell>
  );
}
